import { useAtom, useAtomValue } from 'jotai';
import Image from 'next/image';
import cn from 'classnames';

import { toBase64 } from '../../../../utils/toBase64';
import {
  currentPageAtom,
  isFirstPageImageLoadedAtom,
  zoomLevelAtom,
} from '../../../../store/index.atom';
import PdfPageImage from '../../PdfPageImage';
import { ViewerPageImageItem } from '../index.types';

import * as Styled from './index.styles';

interface Props {
  thumnails: (ViewerPageImageItem | null)[] | null | undefined;
  blindPages?: number[] | null;
}

const DesktopPage = ({ thumnails, blindPages }: Props) => {
  const currentPage = useAtomValue(currentPageAtom);
  const zoomLevel = useAtomValue(zoomLevelAtom);

  /* 첫 번째 이미지가 렌더링 된 이후에, 이후의 페이지들을 렌더링한다 */
  const [isFirstPageImageLoaded, setIsFirstPageImageLoaded] = useAtom(
    isFirstPageImageLoadedAtom,
  );

  const firstItem = thumnails?.[0];

  return (
    <>
      {isFirstPageImageLoaded ? (
        thumnails?.map(
          (item, index) =>
            item?.src && (
              <Styled.ImageWrapper
                className={cn({
                  visible: currentPage === index + 1,
                  hidden: currentPage !== index + 1,
                })}
                key={item.src}
                onContextMenu={(e) => e.preventDefault()}
              >
                {item.imageSources ? (
                  <PdfPageImage
                    viewer={item.imageSources.viewer}
                    alt={`pdf${currentPage}page`}
                    isBlind={blindPages?.includes(index + 1)}
                  />
                ) : (
                  <Image
                    key={zoomLevel}
                    src={item.src}
                    alt={`pdf${currentPage}page`}
                    layout="fill"
                    objectFit="contain"
                    priority
                    placeholder="blur"
                    blurDataURL={`data:image/svg+xml;base64,${toBase64(
                      item.src,
                    )}`}
                    draggable={false}
                    style={{
                      userSelect: 'none',
                      filter: blindPages?.includes(index + 1)
                        ? 'blur(8px)'
                        : 'none',
                    }}
                  />
                )}
              </Styled.ImageWrapper>
            ),
        )
      ) : (
        <Styled.ImageWrapper
          className={cn({
            visible: currentPage === 1,
            hidden: currentPage !== 1,
          })}
          onContextMenu={(e) => e.preventDefault()}
        >
          {firstItem?.src &&
            (firstItem.imageSources ? (
              <PdfPageImage
                viewer={firstItem.imageSources.viewer}
                alt={`pdf${currentPage}page`}
                isBlind={blindPages?.includes(1)}
                onLoad={() => {
                  setIsFirstPageImageLoaded(true);
                }}
              />
            ) : (
              <Image
                key={zoomLevel}
                src={firstItem.src}
                alt={`pdf${currentPage}page`}
                layout="fill"
                objectFit="contain"
                placeholder="blur"
                blurDataURL={`data:image/svg+xml;base64,${toBase64(
                  firstItem.src,
                )}`}
                priority
                onLoadingComplete={() => {
                  setIsFirstPageImageLoaded(true);
                }}
                style={{
                  userSelect: 'none',
                  filter: blindPages?.includes(1) ? 'blur(8px)' : 'none',
                }}
              />
            ))}
        </Styled.ImageWrapper>
      )}
    </>
  );
};

export default DesktopPage;
